// src/components/Footer/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="copyright">&copy; {new Date().getFullYear()} Carl Gathmann. All rights reserved.</p>
        <div className="social-links">
          <a 
            href="https://github.com/CarlGathmann" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-link"
          >
            GitHub
          </a>
          <a 
            href="https://www.linkedin.com/in/carl-gathmann-34084b23a/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-link"
          >
            LinkedIn
          </a>
          <a 
            href="mailto:cjgathmann@gmail.com"
            className="social-link"
          >
            Email
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;